import React from 'react';
import { useParams } from 'react-router-dom';
import { Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetTrip } from 'api/trips/use-get-trip.ts';
import { ECommentEntityName } from 'types/comment.ts';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';
import { EntityAuditLogs } from 'components/common/audit-logs';
import { TripMain } from 'components/trips/trip-main';
import { TripMainInfo } from 'components/trips/trip-main-info';
import { TripPageHeader } from 'components/trips/trip-page-header';
import { TripSteps } from 'components/trips/trip-steps';
import { TripTasks } from 'components/trips/trip-tasks/trip-tasks';
import { TripTotalInfo } from 'components/trips/trip-total-info';

export const TripPage: React.FC = () => {
  const { tripId } = useParams();
  const { data: trip, isLoading } = useGetTrip(Number(tripId));
  const header = !isLoading && trip ? <TripPageHeader trip={trip} /> : undefined;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading && trip ? (
        <Row gutter={16}>
          <Col span={18}>
            <Flex gap='middle' vertical>
              <TripTotalInfo
                totalLDM={trip.totalLDM}
                totalWeight={trip.totalWeight}
                totalVolume={trip.totalVolume}
                loadByLDM={trip.loadByLDM}
                loadByWeight={trip.loadByWeight}
                status={trip.status}
              />

              <TripMain tripId={trip.id} />
              <TripTasks trip={trip} />
              <EntityAuditLogs entityType='trip' entityId={trip.id} />
            </Flex>
          </Col>
          <Col span={6}>
            <Flex gap='middle' vertical>
              <TripMainInfo trip={trip} />
              {trip.carrier ? <ClientInfoCard client={trip.carrier} contact={trip.contact} /> : null}
              <CommentsCard entityName={ECommentEntityName.trip} entityId={trip.id} />
              <TripSteps tripId={trip.id} />
            </Flex>
          </Col>
        </Row>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
